import React from 'react';
import UserProfileContainer from '../../containers/UserProfile';

const UserProfilePage: React.FC = () => {
  return <UserProfileContainer />;
};

export default UserProfilePage;
